"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var HomeModel_1 = require("../../models/HomeModel");
var NeuesEventDialog = /** @class */ (function (_super) {
    __extends(NeuesEventDialog, _super);
    function NeuesEventDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.headlineChanged = function (event, newValue) {
            var data = _this.state.data;
            data.headLine = newValue;
        };
        _this.bodyChanged = function (event, newValue) {
            var data = _this.state.data;
            data.bodyText = newValue;
        };
        _this.onRenderFooterContent = function () { return (React.createElement("div", { style: { minWidth: '200px', maxWidth: '600px' } },
            React.createElement(office_ui_fabric_react_1.Stack, { tokens: { childrenGap: 20 }, horizontal: true },
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "start", grow: true }, _this.state.categorie !== null && _this.state.categorie !== "Home" ?
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDeleteDialog(_this.state.data); }, text: "L\u00F6schen", primaryDisabled: false }) :
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDialog(null); }, text: "Abbrechen", primaryDisabled: false })),
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "end", grow: true, styles: { root: { alignContent: "flex-end", flexGrow: 0 } } },
                    React.createElement(office_ui_fabric_react_1.PrimaryButton, { className: "ms-Default-Button2", onClick: function () { _this.confirmDialog(_this.state.data); }, text: "Speichern" }))))); };
        _this.updateData = function (data, categorie) {
            _this.setState({ data: data, hideDialog: true, categorie: categorie });
        };
        _this.closeDialog = function () {
            _this.setState({ hideDialog: false });
        };
        _this.confirmDialog = function (data) {
            _this.props.confirmedEvent(data);
        };
        _this.confirmDeleteDialog = function (data) {
            _this.props.deleteDataEvent(data);
        };
        _this.state = {
            hideDialog: false, data: new HomeModel_1.default(), categorie: ""
        };
        return _this;
    }
    NeuesEventDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(office_ui_fabric_react_1.Panel, { isOpen: this.state.hideDialog, onDismiss: function () { return _this.confirmDialog(null); }, type: office_ui_fabric_react_1.PanelType.custom, customWidth: "500px", onRenderFooterContent: this.onRenderFooterContent, isFooterAtBottom: true, headerText: this.state.categorie !== null ? this.state.categorie + " bearbeiten" : "Neues Event anlegen" },
            React.createElement("div", { style: { minWidth: "200px", maxWidth: "600px" } },
                React.createElement("div", { style: { paddingLeft: "20px", paddingRight: "20px", paddingBottom: "20px", marginTop: "20px" } },
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "\u00DCberschrift", required: true, defaultValue: this.state.data.headLine, onChange: this.headlineChanged }),
                    React.createElement(office_ui_fabric_react_1.TextField, { label: "Beschreibungstext", multiline: true, rows: 15, defaultValue: this.state.data.bodyText, onChange: this.bodyChanged })))));
    };
    return NeuesEventDialog;
}(React.Component));
exports.default = NeuesEventDialog;
//# sourceMappingURL=NeuesEvent.js.map